
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Trophy } from 'lucide-react';
import { format } from 'date-fns';
import StatsCard from './StatsCard';
import BadgeCard from './BadgeCard';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";

interface OverviewTabProps {
  stats: any;
}

const OverviewTab = ({ stats }: OverviewTabProps) => {
  if (!stats) return null;

  return (
    <div className="space-y-4 mt-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatsCard 
          title="Games Played" 
          value={stats?.totalGamesPlayed || 0} 
          icon={Trophy} 
        />
        
        <StatsCard 
          title="Completion Rate" 
          value={`${Math.round(stats?.completionRate || 0)}%`} 
          showProgress={true}
          progressValue={stats?.completionRate || 0}
        />
        
        <StatsCard 
          title="SOS Used" 
          value={stats?.totalSOSEvents || 0} 
        />
      </div>
      
      {/* Add the BadgeCard component */}
      <BadgeCard totalSOSEvents={stats?.totalSOSEvents || 0} />
      
      <Card className="col-span-3">
        <CardHeader>
          <CardTitle>Weekly Activity</CardTitle>
          <CardDescription>
            Your game sessions and SOS events over the past week
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ChartContainer
              config={{
                games: {
                  label: "Game Sessions",
                  color: "#8BAF96", // sage
                },
                sos: {
                  label: "SOS Events",
                  color: "#FF9A8B", // coral
                },
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={stats?.gamesByDay.map((game: any, index: number) => ({
                    name: format(new Date(game.day), 'EEE'),
                    games: game.count,
                    sos: stats?.sosByDay[index].count,
                  }))}
                >
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Bar dataKey="games" stackId="a" fill="var(--color-games)" />
                  <Bar dataKey="sos" stackId="a" fill="var(--color-sos)" />
                  <ChartTooltip
                    content={
                      <ChartTooltipContent
                        nameKey="name"
                        labelFormatter={(value) => format(new Date(value), 'EEEE')}
                      />
                    }
                  />
                </BarChart>
              </ResponsiveContainer>
            </ChartContainer>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OverviewTab;
